import { AppState } from './app-state';
import { AuthState, User } from 'viewbid-shared-lib';
import { MemoizedSelector, createSelector } from '@ngrx/store';
import {
    CreateProfileResult,
    CreateProfileState,
} from '../modules/profiles/state/create-profile-state';

export const selectAuth: (state: AppState) => AuthState = (state: AppState) =>
    state.auth;

// eslint-disable-next-line
export const selectUser = createSelector<AppState, AuthState, User | null>(
    selectAuth,
    (state: AuthState) => state.user,
);

export function isAdminUser(user: User | null): boolean {
    return user?.roles?.includes('IS_ADMIN') ?? false;
}

export const selectIsAdmin: MemoizedSelector<AppState, boolean> =
    createSelector(selectUser, isAdminUser);

// createProfile is a lazy-loaded feature slice (registered by ProfilesModule)
// — it's genuinely undefined in the store for anyone who reaches a guarded
// eager route (e.g. /auctions, /home) without ProfilesModule ever
// having loaded, so the type here reflects that rather than lying about it.
export const selectCreatedProfile: (
    state: AppState,
) => CreateProfileState | undefined = (state: AppState) => state.createProfile;

// eslint-disable-next-line
export const createdProfile = createSelector<
    AppState,
    CreateProfileState | undefined,
    CreateProfileResult | null
>(
    selectCreatedProfile,
    (state: CreateProfileState | undefined) => state?.result ?? null,
);
